/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Created by alvinoktavianus on 7/21/17.
 */

import moment from 'moment';
import pushClevertapEvent from '../pushClevertapEvent';

export function settingBillingPay({ billingData }) {
  pushClevertapEvent('Setting Billing Pay', {
    'Billing Cycle':
      billingData.subscription_name !== 'Monthly'
        ? 'Annual'
        : billingData.subscription_name,
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.purchased_outlets.length,
  });
}

function getRenewalData(billingData) {
  return {
    'Business Id': billingData.business_id,
    'Billing Cycle':
      billingData.subscription_name !== 'Monthly'
        ? 'Annual'
        : billingData.subscription_name,
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.purchased_outlets.length,
    Timestamp: moment().format(),
  };
}

export function renewalFullFlow({ billingData }) {
  pushClevertapEvent('Renewal Full Flow', getRenewalData(billingData));
}

export function renewalBannerClick({ billingData }) {
  pushClevertapEvent('Renewal Banner Click', getRenewalData(billingData));
}

export function renewalBillingPay({ billingData }) {
  pushClevertapEvent('Renewal Billing Pay', getRenewalData(billingData));
}

export function mpCancelFeatureSubscription(
  bussiness,
  featureName,
  expiredDate
) {
  pushClevertapEvent('Cancel Subscription Feature', {
    'Business Id': bussiness.id,
    'Feature Name': featureName.feature_name,
    'Subscribe Expired Date': expiredDate,
  });
}

export function mpUpdateSubscriptionOutlet(
  isActiveSubscription,
  bussinessId,
  outletName,
  expiredDate
) {
  let title = 'Turn On Subscription Outlet';
  if (!isActiveSubscription) {
    title = 'Turn Off Subscription Outlet';
  }
  pushClevertapEvent(title, {
    'Business Id': bussinessId,
    'Feature Name': outletName,
    'Subscribe Expired Date': expiredDate,
  });
}
